import React, { useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import useData from '../../hooks/useData';
import useClickOutside from '../../hooks/useClickOutside';
import { getPriorityColor } from '../../utils/helpers';

const PriorityChanger = ({ task }) => {
    const { handleUpdateTask } = useData();
    const [isOpen, setIsOpen] = useState(false);
    const buttonRef = useRef(null);
    const dropdownRef = useRef(null);
    const [position, setPosition] = useState({ top: 0, left: 0 });

    useClickOutside(dropdownRef, () => {
        if(isOpen) setIsOpen(false);
    }, buttonRef);

    const priorities = ['Alta', 'Média', 'Baixa'];

    const handleChangePriority = (newPriority) => {
        if (task.priority !== newPriority) {
            handleUpdateTask(task.id, { priority: newPriority }, `alterou a prioridade para ${newPriority}.`);
        }
        setIsOpen(false);
    };

    const openDropdown = () => {
        if (!buttonRef.current) return;
        
        const rect = buttonRef.current.getBoundingClientRect();
        const dropdownWidth = 144; // w-36
        const estimatedDropdownHeight = 120;
        
        // Decide se abre para cima ou para baixo com base no espaço disponível
        const spaceAbove = rect.top;
        const spaceBelow = window.innerHeight - rect.bottom;
        
        let topPosition;
        if (spaceBelow < estimatedDropdownHeight && spaceAbove > spaceBelow) {
            // Abre para cima
            topPosition = rect.top - estimatedDropdownHeight - 8;
        } else {
            // Abre para baixo
            topPosition = rect.bottom + 8;
        }

        setPosition({
            top: topPosition,
            left: rect.right - dropdownWidth,
        });
        setIsOpen(true);
    };

    const renderDropdown = () => {
        if (!isOpen) return null;

        return ReactDOM.createPortal(
            <div
                ref={dropdownRef}
                style={{
                    position: 'fixed',
                    top: `${position.top}px`,
                    left: `${position.left}px`,
                    width: '144px',
                    zIndex: 1000,
                }}
                className="bg-gray-900 border border-white/10 rounded-lg shadow-xl p-1 z-50 animate-fade-in"
            >
                {priorities.map(p => (
                    <button
                        key={p}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleChangePriority(p);
                        }}
                        className="w-full text-left flex items-center gap-2 p-2 rounded-md text-sm text-gray-200 hover:bg-white/10"
                    >
                        <div className="w-3 h-3 rounded-full" style={{ backgroundColor: getPriorityColor(p) }} />
                        <span>{p}</span>
                    </button>
                ))}
            </div>,
            document.getElementById('portal-root')
        );
    };

    return (
        <div className="relative">
            <button
                ref={buttonRef}
                onClick={(e) => {
                    e.stopPropagation();
                    openDropdown();
                }}
                title={`Prioridade: ${task.priority}`}
                className="w-4 h-4 rounded-full transition-transform hover:scale-125"
                style={{ backgroundColor: getPriorityColor(task.priority) }}
            />
            {renderDropdown()}
        </div>
    );
};

export default PriorityChanger;